import { useQuery } from '@tanstack/react-query';
import { availabilityReportService } from '@/services';
import { queryKeys } from '@/services/query-keys';

export const useAvailabilityReportDetail = (id: number | null) => {
  return useQuery({
    queryKey: queryKeys.availabilityReport.detail(id ?? 0),
    queryFn: () => availabilityReportService.getAvailabilityReportDetail(id as number),
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
    enabled: id !== null,
  });
};
